import { Directive, OnInit, Input, ViewContainerRef, TemplateRef, OnChanges } from '@angular/core';
import { UserResourcesEnum, UserResourcesService } from '../services/resource/user-resources.service';

@Directive({ selector: '[resourceRequired]' })
export class ResourceDirective implements OnInit, OnChanges {
	@Input('resourceRequired') resourceRequired: UserResourcesEnum | { res: UserResourcesEnum, applyOn: boolean };

	constructor(private view: ViewContainerRef,
		private userResourceService: UserResourcesService,
		private template: TemplateRef<HTMLBaseElement>) {
		this.view = view;
		this.userResourceService = userResourceService;
		this.template = template;
	}

	ngOnInit(): void {
		this.validateComponent();
	}

	ngOnChanges() {
		this.validateComponent();
	}

	validateComponent() {
		this.toggleComponent();
		this.userResourceService.sessionResources.subscribe((resources) => {
			if (resources.length > 0) this.eraseComponentIfDoNotHaveResource();
		});
	}

	eraseComponentIfDoNotHaveResource() {
		try {
			if (typeof this.resourceRequired == "string") {
				if (!this.userResourceService.validateResource(this.resourceRequired)) {
					this.removeComponent();
				} else this.toggleComponent();
			} else {
				if (this.resourceRequired.applyOn) {
					if (!this.userResourceService.validateResource(this.resourceRequired.res)) {
						this.removeComponent();
					} else this.toggleComponent();
				} else this.toggleComponent();
			}
		} catch (error) {
			console.error(`Erro ao validar segurança do resource ${this.resourceRequired}`);
			this.removeComponent();
		}
	}

	removeComponent() {
		this.view.clear();
	}

	toggleComponent() {
		if (!this.view.length) {
			this.view.createEmbeddedView(this.template);
		}
	}
}

